import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects'
import axios from 'axios'
import {
  acceptAction,
  rejectAction,
} from '@Infowijs-eng/component-library/modules/reduxPromiseHelpers'
import { debounceAction } from '@Infowijs-eng/component-library/modules/authentication'
import { serviceEndpoints } from '@Infowijs-eng/component-library/modules'
import actionTypes from '../../action-types'
import inviteAdministrator from '../../actions/administrators/inviteAdministrator'
import awaitAccessToken from '../../modules/awaitAccessToken'

const onInviteAdministrator = function* onInviteAdministrator() {
  yield takeLatest(actionTypes.ADMINISTRATORS.INVITE, function* onInviteAdministratorSaga(action) {
    const { payload } = action
    const accessToken = yield call(awaitAccessToken)

    let response
    try {
      response = yield call(axios, {
        url: `${serviceEndpoints.administrators}`,
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'X-Infowijs-Client': 'nl.infowijs.admin',
          'Content-Type': 'application/vnd.infowijs.v1+json',
          Accept: 'application/vnd.infowijs.v1+json',
        },
        data: payload,
      })
    } catch (e) {
      if (e.response.status === 401) {
        yield debounceAction(function* reInviteAdministrator() {
          yield put(inviteAdministrator(payload))
        })
      }

      rejectAction(action, e.response.data.errors)

      return
    }

    if (!response || !response.data) {
      return
    }

    acceptAction(action, response.data.data)
  })
}

export default onInviteAdministrator
